"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StakingWrapper = void 0;
var ethers_1 = require("ethers");
var stakingContractABI_1 = __importDefault(require("./abi/stakingContractABI"));
var erc20ABI_1 = __importDefault(require("./abi/erc20ABI"));
function getAddresses(isTestingMode) {
    // Testing addresses
    var stakingContractTestingAddress = '0xc6388a003eA280CB36fF37545Ab90Db63D1a480D';
    var stakingTokenTestingAddress = '0x60a2062041cA912A28c2BdB01905F328df265DC9';
    // Production addresses
    var stakingContractAddress = '0xd9ec2Eb8bf3081aAF38B29bB25404bC614E3bF11';
    var stakingTokenAddress = '0xF9cea445c2Ac1668f50CAa2c2924F93606a4a37d';
    return {
        stakingContractAddress: isTestingMode
            ? stakingContractTestingAddress
            : stakingContractAddress,
        tokenContractAddress: isTestingMode
            ? stakingTokenTestingAddress
            : stakingTokenAddress
    };
}
/**
 * Wrapper aroung staking and ERC20 contracts
 */
var StakingWrapper = /** @class */ (function () {
    function StakingWrapper(isTestingMode, signer, provider) {
        this.signer = signer;
        this.provider = provider;
        var addresses = getAddresses(isTestingMode);
        this.stakingContract = new ethers_1.ethers.Contract(addresses.stakingContractAddress, stakingContractABI_1.default, signer);
        this.stakingTokenContract = new ethers_1.ethers.Contract(addresses.tokenContractAddress, erc20ABI_1.default, signer);
    }
    /**
     * Gives staking contract allowance to spend staking tokens
     * @param amount Amount to stake
     */
    StakingWrapper.prototype.approve = function (amount) {
        return __awaiter(this, void 0, void 0, function () {
            var tx;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Approve tokens to spend
                        console.log('[approve] approving tokens');
                        return [4 /*yield*/, this.stakingTokenContract
                                .approve(this.stakingContract.address, amount)];
                    case 1:
                        tx = _a.sent();
                        return [4 /*yield*/, tx.wait()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Returns allowance for staking contract
     */
    StakingWrapper.prototype.getAllowance = function () {
        return __awaiter(this, void 0, void 0, function () {
            var signerAddress;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.signer.getAddress()];
                    case 1:
                        signerAddress = _a.sent();
                        return [4 /*yield*/, this.stakingTokenContract.connect(this.provider).allowance(signerAddress, this.stakingContract.address)];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Allows user to stake funds
     *
     * @param amount Amount to stake
     * @param lockOptions Options for locking funds. Do not pass them if you wan't to stake without lock
     * @returns Transaction result
     */
    StakingWrapper.prototype.stake = function (amount, lockDurationInEpochs) {
        return __awaiter(this, void 0, void 0, function () {
            var currentAllowance, amountToStake, minimalDuration, lockEpochDuration, chosenDuration, stakeTx_1, stakeTx;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAllowance()];
                    case 1:
                        currentAllowance = _a.sent();
                        amountToStake = ethers_1.BigNumber.from(amount);
                        if (!currentAllowance.lt(amountToStake)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.approve(amountToStake)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        if (!lockDurationInEpochs) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.getMinimalLockDuration()];
                    case 4:
                        minimalDuration = _a.sent();
                        return [4 /*yield*/, this.getLockEpochDuration()];
                    case 5:
                        lockEpochDuration = _a.sent();
                        chosenDuration = lockEpochDuration.mul(ethers_1.BigNumber.from(lockDurationInEpochs));
                        if (chosenDuration.lt(minimalDuration)) {
                            throw new Error("You should choose a longer lock. Minimal duration is: " + minimalDuration.toString());
                        }
                        return [4 /*yield*/, this.stakingContract
                                .stake(amount, true, lockDurationInEpochs)];
                    case 6:
                        stakeTx_1 = _a.sent();
                        return [4 /*yield*/, stakeTx_1.wait()];
                    case 7: return [2 /*return*/, _a.sent()];
                    case 8: return [4 /*yield*/, this.stakingContract
                            .stake(amount, false, 0)];
                    case 9:
                        stakeTx = _a.sent();
                        return [4 /*yield*/, stakeTx.wait()];
                    case 10: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Allows user to withdraw funds from staking
     * @param stakeId ID of stake to withdraw
     * @param amount Amount to withdraw
     * @returns Transaction result
     */
    StakingWrapper.prototype.withdraw = function (stakeId, amount) {
        return __awaiter(this, void 0, void 0, function () {
            var tx;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.stakingContract
                            .withdraw(stakeId, amount)];
                    case 1:
                        tx = _a.sent();
                        return [4 /*yield*/, tx.wait()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Allows user to reinvest his reward
     * @param stakeID ID of stake to reinvest
     * @param lockOptions Options for locking funds. Do not pass them if you wan't to stake without lock
     * @returns Transaction result
     */
    StakingWrapper.prototype.reinvest = function (stakeId, lockDurationInEpochs) {
        return __awaiter(this, void 0, void 0, function () {
            var minimalDuration, lockEpochDuration, chosenDuration, tx_1, tx;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!lockDurationInEpochs) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.getMinimalLockDuration()];
                    case 1:
                        minimalDuration = _a.sent();
                        return [4 /*yield*/, this.getLockEpochDuration()];
                    case 2:
                        lockEpochDuration = _a.sent();
                        chosenDuration = lockEpochDuration.mul(ethers_1.BigNumber.from(lockDurationInEpochs));
                        if (chosenDuration.lt(minimalDuration)) {
                            throw new Error("You should choose a longer lock. Minimal duration is: " + minimalDuration.toString());
                        }
                        return [4 /*yield*/, this.stakingContract
                                .reinvest(stakeId, true, lockDurationInEpochs)];
                    case 3:
                        tx_1 = _a.sent();
                        return [4 /*yield*/, tx_1.wait()];
                    case 4: return [2 /*return*/, _a.sent()];
                    case 5: return [4 /*yield*/, this.stakingContract
                            .reinvest(stakeId, false, 0)];
                    case 6:
                        tx = _a.sent();
                        return [4 /*yield*/, tx.wait()];
                    case 7: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Allows user to harvest his reward
     * @param stakeId ID of stake to harvest reward
     * @param lockOptions Options for locking funds. Passing them makes sense only
     * for staking plan with lock since user stop getting reward when lock ends
     * @returns Transaction result
     */
    StakingWrapper.prototype.harvest = function (stakeId, lockDurationInEpochs) {
        return __awaiter(this, void 0, void 0, function () {
            var minimalDuration, lockEpochDuration, chosenDuration, tx_2, tx;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!lockDurationInEpochs) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.getMinimalLockDuration()];
                    case 1:
                        minimalDuration = _a.sent();
                        return [4 /*yield*/, this.getLockEpochDuration()];
                    case 2:
                        lockEpochDuration = _a.sent();
                        chosenDuration = lockEpochDuration.mul(ethers_1.BigNumber.from(lockDurationInEpochs));
                        if (chosenDuration.lt(minimalDuration)) {
                            throw new Error("You should choose a longer lock. Minimal duration is: " + minimalDuration.toString());
                        }
                        return [4 /*yield*/, this.stakingContract
                                .harvest(stakeId, true, lockDurationInEpochs)];
                    case 3:
                        tx_2 = _a.sent();
                        return [4 /*yield*/, tx_2.wait()];
                    case 4: return [2 /*return*/, _a.sent()];
                    case 5: return [4 /*yield*/, this.stakingContract
                            .harvest(stakeId, false, 0)];
                    case 6:
                        tx = _a.sent();
                        return [4 /*yield*/, tx.wait()];
                    case 7: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Obtains staking APR from staking contract
     * @param isLocked Return APR for staking with lock or without
     * @returns APR for chosen staking plan
     */
    StakingWrapper.prototype.getStakingReward = function (isLocked) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.stakingContract.connect(this.provider).getStakingReward(isLocked)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Obtains minimal duration of lock
     * @returns Minimal duration of lock
     */
    StakingWrapper.prototype.getMinimalLockDuration = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.stakingContract.connect(this.provider).lockDuration()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Obtains duration of one lock epoch
     * @returns Lock epoch duration
     */
    StakingWrapper.prototype.getLockEpochDuration = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.stakingContract.connect(this.provider).lockEpochDuration()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns all stake ids made by user
     * @param address User address
     * @returns Array of stake IDs made by given user
     */
    StakingWrapper.prototype.getStakesByAddress = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.stakingContract.connect(this.provider).getStakesByAddress(address)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns stake data by its ID
     * @param stakeID ID of the stake
     * @returns Struct with stake data
     */
    StakingWrapper.prototype.getStakeData = function (stakeID) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.stakingContract.connect(this.provider).getStakeData(stakeID)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Calculates abstract reward using provided duration, amount and lock options
     * @param duration Duration of stake in seconds
     * @param amount Staked amount
     * @param lockOptions Lock options
     */
    StakingWrapper.prototype.calculateRewardRaw = function (duration, amount, apr) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.stakingContract.connect(this.provider).calculateReward(amount, duration, apr)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    StakingWrapper.prototype.bigNumberToDate = function (number) {
        return new Date(parseInt(number.mul(1000).toString()));
    };
    /**
     * Returns data of all stakes made by user
     * @param address User address
     * @returns Array of stake data
     */
    StakingWrapper.prototype.getAllStakeDataByAddress = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var result, ids, i, data, earned;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        result = [];
                        return [4 /*yield*/, this.getStakesByAddress(address)];
                    case 1:
                        ids = _a.sent();
                        i = 0;
                        _a.label = 2;
                    case 2:
                        if (!(i < ids.length)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.getStakeData(ids[i])];
                    case 3:
                        data = _a.sent();
                        return [4 /*yield*/, this.calculateRewardByStakeId(ids[i])];
                    case 4:
                        earned = _a.sent();
                        result.push({ data: data, stakeId: ids[i], earned: earned });
                        _a.label = 5;
                    case 5:
                        i++;
                        return [3 /*break*/, 2];
                    case 6: return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     * Returns balance in staking tokens
     * @param address Holder address
     * @returns Balance in staking tokens
     */
    StakingWrapper.prototype.getStakingTokenBalance = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.stakingTokenContract.connect(this.provider).balanceOf(address)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    StakingWrapper.prototype.reinvestAll = function (isLocked) {
        return __awaiter(this, void 0, void 0, function () {
            var tx;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.stakingContract.reinvestAll(isLocked)];
                    case 1:
                        tx = _a.sent();
                        return [4 /*yield*/, tx.wait()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    StakingWrapper.prototype.harvestAll = function (isLocked) {
        return __awaiter(this, void 0, void 0, function () {
            var tx;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.stakingContract.harvestAll(isLocked)];
                    case 1:
                        tx = _a.sent();
                        return [4 /*yield*/, tx.wait()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    StakingWrapper.prototype.getBlockTimestamp = function () {
        return __awaiter(this, void 0, void 0, function () {
            var blockNumber, block;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.signer.provider) {
                            return [2 /*return*/, 0];
                        }
                        return [4 /*yield*/, this.provider.getBlockNumber()];
                    case 1:
                        blockNumber = _a.sent();
                        return [4 /*yield*/, this.provider.getBlock(blockNumber)];
                    case 2:
                        block = _a.sent();
                        return [2 /*return*/, block.timestamp];
                }
            });
        });
    };
    StakingWrapper.prototype.getHarvestHistory = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var filter, logs, result, i, blockData, timestamp, log;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        filter = this.stakingContract.connect(this.provider).filters.Harvest(null, address, null);
                        return [4 /*yield*/, this.stakingContract.connect(this.provider).queryFilter(filter)];
                    case 1:
                        logs = _a.sent();
                        result = [];
                        i = 0;
                        _a.label = 2;
                    case 2:
                        if (!(i < logs.length)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.provider.getBlock(logs[i].blockHash)];
                    case 3:
                        blockData = _a.sent();
                        timestamp = blockData === null || blockData === void 0 ? void 0 : blockData.timestamp;
                        log = this.stakingContract.interface.parseLog(logs[i]);
                        result.push({
                            stakeId: log.args.stakeId, amount: log.args.amount,
                            timestamp: timestamp
                        });
                        _a.label = 4;
                    case 4:
                        i++;
                        return [3 /*break*/, 2];
                    case 5: return [2 /*return*/, result];
                }
            });
        });
    };
    StakingWrapper.prototype.getReinvestHistory = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var filter, logs, result, i, blockData, timestamp, log;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        filter = this.stakingContract.connect(this.provider).filters.Reinvest(null, address, null);
                        return [4 /*yield*/, this.stakingContract.connect(this.provider).queryFilter(filter)];
                    case 1:
                        logs = _a.sent();
                        result = [];
                        i = 0;
                        _a.label = 2;
                    case 2:
                        if (!(i < logs.length)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.provider.getBlock(logs[i].blockHash)];
                    case 3:
                        blockData = _a.sent();
                        timestamp = blockData === null || blockData === void 0 ? void 0 : blockData.timestamp;
                        log = this.stakingContract.interface.parseLog(logs[i]);
                        result.push({
                            stakeId: log.args.stakeId, amount: log.args.amount,
                            timestamp: timestamp
                        });
                        _a.label = 4;
                    case 4:
                        i++;
                        return [3 /*break*/, 2];
                    case 5: return [2 /*return*/, result];
                }
            });
        });
    };
    StakingWrapper.prototype.getTotalStakedByAddress = function (address, isLocked) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.stakingContract.connect(this.provider).getTotalStakedByAddress(address, isLocked)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    StakingWrapper.prototype.calculateRewardByStakeId = function (stakeId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.stakingContract.connect(this.provider).calculateRewardByStakeId(stakeId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    StakingWrapper.prototype.getTotalStaked = function (isMainnet) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!isMainnet) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.stakingContract.connect(this.provider).totalSupply()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [4 /*yield*/, this.getTotalStakedInner(null, null)];
                    case 3: 
                    // If we're using testnet there is no such limitation
                    return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    StakingWrapper.prototype.getTotalStakedInner = function (fromBlock, toBlock) {
        return __awaiter(this, void 0, void 0, function () {
            var reinvestFilter, reinvestLogs, withdrawFilter, withdrawLogs, stakeFilter, stakeLogs, totalStaked, totalReinvested, totalWithdraw, finalStakedAmount;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        reinvestFilter = this.stakingContract.connect(this.provider).filters.Reinvest(null, null, null);
                        return [4 /*yield*/, this.stakingContract.connect(this.provider).queryFilter(reinvestFilter)];
                    case 1:
                        reinvestLogs = _a.sent();
                        withdrawFilter = this.stakingContract.connect(this.provider).filters.Withdraw(null, null, null);
                        return [4 /*yield*/, this.stakingContract.connect(this.provider).queryFilter(withdrawFilter)];
                    case 2:
                        withdrawLogs = _a.sent();
                        stakeFilter = this.stakingContract.connect(this.provider).filters.Stake(null, null, null, null);
                        return [4 /*yield*/, this.stakingContract.connect(this.provider).queryFilter(stakeFilter)];
                    case 3:
                        stakeLogs = _a.sent();
                        totalStaked = stakeLogs.reduce(function (acc, v) { var _a; return acc.add((_a = v === null || v === void 0 ? void 0 : v.args) === null || _a === void 0 ? void 0 : _a.amount); }, ethers_1.ethers.BigNumber.from(0));
                        totalReinvested = reinvestLogs.reduce(function (acc, v) { var _a; return acc.add((_a = v === null || v === void 0 ? void 0 : v.args) === null || _a === void 0 ? void 0 : _a.amount); }, ethers_1.ethers.BigNumber.from(0));
                        totalWithdraw = withdrawLogs.reduce(function (acc, v) { var _a; return acc.add((_a = v === null || v === void 0 ? void 0 : v.args) === null || _a === void 0 ? void 0 : _a.amount); }, ethers_1.ethers.BigNumber.from(0));
                        finalStakedAmount = totalStaked.add(totalReinvested).sub(totalWithdraw);
                        return [2 /*return*/, finalStakedAmount];
                }
            });
        });
    };
    return StakingWrapper;
}());
exports.StakingWrapper = StakingWrapper;
